import { Grid, TextField, Button, FormControl, RadioGroup, FormControlLabel, Radio, Switch } from '@mui/material'

export const SeccionGeneralCat = ({ initialState, form, onInputChange, handleSubmitCat }) => {
    return (
        <div style={{ marginTop: '5px' }}>
            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                <Grid item xs={12}>
                    <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                        {form.id > 0 &&
                            <FormControlLabel
                                className="ms-2"
                                control={
                                    <Switch
                                        style={{ color: form?.estado ? '#8E24AA' : '' }}
                                        name="estado"
                                        checked={form?.estado}
                                        onChange={onInputChange}
                                    />
                                }
                                label={form?.estado ? 'Activo' : 'Desactivado'}
                            />
                        }

                        <Grid item xs={12}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="tipo"
                                    onChange={onInputChange}
                                >
                                    <FormControlLabel
                                        value="venta"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form?.tipo === 'venta' ? true : false} />}
                                        label="Venta"
                                    />
                                    <FormControlLabel
                                        value="compra"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form?.tipo === 'compra' ? true : false} />}
                                        label="Compra"
                                    />
                                    <FormControlLabel
                                        value="ambos"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form?.tipo === 'ambos' ? true : false} />}
                                        label="Compra/venta"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={4}>
                            <div className='p-info'>
                                <TextField
                                    className='p-info-code '
                                    label="Código"
                                    name="codigo"
                                    id="outlined-size-small"
                                    value={form?.codigo || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese código'
                                    onChange={onInputChange}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <div className='p-info'>
                                <TextField
                                    label="Nombre categoría (*)"
                                    name="nombre"
                                    id="outlined-size-small"
                                    value={form?.nombre || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese nombre categoría'
                                    onChange={onInputChange}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                name="descripcion"
                                label="Descripción"
                                multiline
                                rows={6}
                                value={form?.descripcion}
                                onChange={onInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} className="text-end">

                            {form.id > 0 &&
                                <Button
                                    id="id-button-save-ppto"
                                    disabled={initialState === form}
                                    className='p-btn-primary'
                                    variant="contained"
                                    size='medium'
                                    onClick={() => handleSubmitCat('actualizar')}
                                    type='button'
                                >
                                    {''}Actualizar
                                </Button>
                            }

                            {form.id === 0 &&

                                <>
                                    <Button
                                        disabled={initialState === form}
                                        className='p-btn-primary-large'
                                        variant="contained"
                                        size='medium'
                                        onClick={() => handleSubmitCat('saveAndMore')}
                                        type='button'
                                    >
                                        {''}Guardar y agregar más
                                    </Button>
                                    <Button
                                        disabled={initialState === form}
                                        className='p-btn-primary-large ms-2'
                                        variant="contained"
                                        size='medium'
                                        onClick={() => handleSubmitCat('saveAndExit')}
                                        type='button'
                                    >
                                        {''}Guardar y salir
                                    </Button>
                                </>

                            }

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>
        </div>
    )
}
